import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaLock, FaEnvelope, FaSignInAlt } from 'react-icons/fa';
import axios from 'axios';
import { isTokenExpired } from '../apis/axiosConfig';
import logo from '../asserts/img/logo.png';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api/v1';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      if (!isTokenExpired(token)) {
        navigate('/dashboard');
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.clear();
      }
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error('Please enter email and password');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE}/admin/signin`, {
        username: username.trim().toLowerCase(),
        password: password.trim()
      });

      if (res?.data && res.data.access_token) {
        localStorage.setItem('token', res.data.access_token);
        localStorage.setItem('user', JSON.stringify({ email: username.trim(), name: res.data.name || 'Admin', role: 'admin' }));
        toast.success('Login successful!');
        setTimeout(() => {
          navigate('/dashboard');
        }, 400);
      } else {
        toast.error(res?.data?.message || 'Invalid email or password');
      }
    } catch (err) {
      console.error('Login error:', err);
      const errMsg = err.response?.data?.message || 'Invalid email or password';
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#070707',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: '20px'
      }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      <div
        style={{
          width: '100%',
          maxWidth: '440px',
          backgroundColor: '#121215',
          borderRadius: '16px',
          border: '1px solid #2a2620',
          padding: '40px 32px',
          boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
          textAlign: 'center'
        }}
      >
        {/* Brand Header */}
        <div style={{ marginBottom: '28px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img
            src={logo}
            alt="ARISTO Logo"
            style={{
              height: '42px',
              maxWidth: '220px',
              objectFit: 'contain',
              marginBottom: '12px',
              filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.6))'
            }}
          />
          <div
            style={{
              fontSize: '11px',
              letterSpacing: '2.5px',
              color: '#8a8377',
              textTransform: 'uppercase',
              fontWeight: 600
            }}
          >
            Enquiry Management Portal
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} autoComplete="off" style={{ textAlign: 'left' }}>
          <div style={{ marginBottom: '20px' }}>
            <label
              htmlFor="usernameInput"
              style={{
                display: 'block',
                fontSize: '11px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                color: '#aaa',
                marginBottom: '8px'
              }}
            >
              Email Address / Username
            </label>
            <div style={{ position: 'relative' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#666'
                }}
              >
                <FaEnvelope size={14} />
              </span>
              <input
                id="usernameInput"
                type="text"
                autoComplete="off"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin@gmail.com"
                style={{
                  width: '100%',
                  padding: '12px 14px 12px 40px',
                  backgroundColor: '#0a0a0c',
                  border: '1px solid #2d2d35',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <label
              htmlFor="passwordInput"
              style={{
                display: 'block',
                fontSize: '11px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                color: '#aaa',
                marginBottom: '8px'
              }}
            >
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#666'
                }}
              >
                <FaLock size={14} />
              </span>
              <input
                id="passwordInput"
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%',
                  padding: '12px 14px 12px 40px',
                  backgroundColor: '#0a0a0c',
                  border: '1px solid #2d2d35',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#c4a882',
              border: 'none',
              borderRadius: '8px',
              color: '#000',
              fontSize: '13px',
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '2px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'opacity 0.2s ease',
              opacity: loading ? 0.7 : 1
            }}
          >
            <FaSignInAlt size={14} />
            {loading ? 'Authenticating...' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: '24px', fontSize: '11px', color: '#555' }}>
          &copy; {new Date().getFullYear()} ARISTO INDIA. Protected Administrative Access.
        </div>
      </div>
    </div>
  );
}

export default Login;
